import React from "react";


function PieChartIcon(props) {

  return (
    <svg width="24" height="25" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" fill="none" { ...props }>
      <path d="M16.396 8.22165C16.614 8.22065 16.79 8.04365 16.79 7.82665C16.79 7.60865 16.613 7.43265 16.395 7.43265C16.177 7.43265 16 7.60865 16 7.82665C16 8.04465 16.177 8.22165 16.395 8.22165" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16.396 3.99121C16.603 3.99021 16.77 3.82221 16.77 3.61521C16.77 3.40821 16.602 3.24121 16.395 3.24121C16.188 3.24121 16.02 3.40921 16.02 3.61621C16.02 3.82321 16.188 3.99121 16.396 3.99121" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M20.98 7.82615C20.98 7.61915 20.812 7.45215 20.605 7.45215C20.398 7.45215 20.231 7.62015 20.231 7.82715C20.231 8.03415 20.399 8.20215 20.606 8.20215C20.812 8.20215 20.98 8.03415 20.98 7.82615" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 21.2217V3.22168C7.029 3.22168 3 7.25068 3 12.2217C3 17.1927 7.029 21.2217 12 21.2217C16.971 21.2217 21 17.1927 21 12.2217H12" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export default PieChartIcon;
